// Estado de la recepción de rehusados
export enum ReturnedReceptionStatus {
  CLOSED = 0,
  OPEN = 1,
  POR_UBICAR = 2,
  PENDING_OPEN = 3,
}

// Modelo para la recepción de rehusados
export interface ReturnedReception {
  id: number;
  status: ReturnedReceptionStatus;
  team_id: string | number;
  total_orders: number;
  orders_count?: number;
  code: string;
  reception_id: number | null;
  created_at: string;
  updated_at: string;
}

// Respuesta paginada de la API
export interface ReturnedReceptionsApiResponse {
  data: ReturnedReception[];
  meta: {
    total: number;
    perPage: number;
    currentPage: number;
    lastPage: number;
  };
  links: {
    first: string;
    prev: string | null;
    next: string | null;
    last: string;
  };
}

// Parámetros de filtro para el listado
export interface ReturnedReceptionFilters {
  search?: string;
  status?: ReturnedReceptionStatus;
  from_date?: string;
  to_date?: string;
  page?: number;
  per_page?: number;
  order_by?: string;
  order_direction?: 'asc' | 'desc';
}

// Request para crear una recepción
export interface CreateReceptionRequest {
  total_orders: number;
  reception_id?: number;
}

// Response al crear una recepción
export interface CreateReceptionResponse {
  id: number;
}

// Filtros para queries con infinite scroll
export interface Filters {
  searchTerm?: string;
  status?: ReturnedReceptionStatus;
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
  page?: number;
}
